import api from '@/api/index.js'

const season_tickets = {
  state: {
    loading: false,
    updating: false,
    data: null,
    single: null, // Represents single retrieved season_ticket
    created: null,
    error: null,
    availableTraits: ["none", "revocable"]
  },

  mutations: {
    SET_SEASON_TICKETS_LOADING: (state, loading) => {
      state.loading = loading;
    },
    SET_SEASON_TICKETS_UPDATING: (state, updating) => {
      state.updating = updating;
    },
    SET_SEASON_TICKETS: (state, data) => {
      state.data = data
      state.loading = false;
    },
    SET_SEASON_TICKET: (state, data) => {
      state.single = data
      state.loading = false;
    },
    SET_SEASON_TICKETS_ERROR: (state, error) => {
      state.error = error
    },
    SET_SEASON_TICKET_CREATED: (state, created) => {
      state.created = created
    }
  },

  actions: {
    LoadSeasonTickets({commit}) {
      commit('SET_SEASON_TICKETS_LOADING', true)
      commit('SET_SEASON_TICKETS_ERROR', null)
      return api.get('season-tickets?limit=150&offset=0')
        .then((response) => {
          commit('SET_SEASON_TICKETS', response)
        })
        .catch((error) => {
          commit('SET_SEASON_TICKETS_ERROR', error)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_SEASON_TICKETS_LOADING', false)
        })
    },
    GetSeasonTicket({commit}, id) {
      commit('SET_SEASON_TICKET', null)
      commit('SET_SEASON_TICKETS_ERROR', null)
      commit('SET_SEASON_TICKETS_LOADING', true)
      return api.get(`season-tickets/${id}`)
        .then((response) => {
          commit('SET_SEASON_TICKET', response)
        })
        .catch((error) => {
          commit('SET_SEASON_TICKETS_ERROR', error)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_SEASON_TICKETS_LOADING', false)
        })
    },
    CreateSeasonTicket({commit}, payload) {
      commit('SET_SEASON_TICKETS_UPDATING', true);
      commit('SET_SEASON_TICKETS_ERROR', null)
      commit('SET_SEASON_TICKET_CREATED', null)
      return api.post(`season-tickets`, payload.data)
        .then((response) => {
          commit('SET_SEASON_TICKET_CREATED', response.body)
          commit('SET_SEASON_TICKETS_UPDATING', false);
        })
        .catch((error) => {
          commit('SET_SEASON_TICKETS_ERROR', error)
          commit('SET_SEASON_TICKETS_UPDATING', false);
        })
    },
    UpdateSeasonTicket({commit}, payload) {
      commit('SET_SEASON_TICKETS_ERROR', null)
      commit('SET_ERROR', null)
      commit('SET_SEASON_TICKETS_UPDATING', true)
      return api.put(`season-tickets/${payload.id}`, payload.data)
        .then((response) => {
          commit('SET_SEASON_TICKETS_UPDATING', false)
          commit('SET_SEASON_TICKET', response.body)
        })
        .catch((error) => {
          commit('SET_SEASON_TICKETS_UPDATING', false)
          commit('SET_SEASON_TICKETS_ERROR', error)
          if (!payload.formSubmit) {
            commit('SET_INTERACTION_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          }
        })
    },
    DeleteSeasonTicket({commit}, id) {
      commit('SET_ERROR', null)
      commit('SET_SEASON_TICKETS_UPDATING', true);
      commit('SET_SEASON_TICKETS_ERROR', null)
      return api.delete(`season-tickets/${id}`)
        .then((response) => {
          commit('SET_SEASON_TICKETS_UPDATING', false);
        })
        .catch((error) => {
          commit('SET_SEASON_TICKETS_ERROR', error)
          commit('SET_INTERACTION_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_SEASON_TICKETS_UPDATING', false);
        })
    }
  }
}

export default season_tickets
